import React, { createContext, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { registerContentType } from '../components/content/ContentTypeRegistry';

const ContentTypeContext = createContext(null);

export const useContentTypeRegistry = () => useContext(ContentTypeContext);

/**
 * Provider to initialize the ContentTypeRegistry with app-specific configurations.
 */
export const ContentTypeProvider = ({ children, contentTypes = {} }) => {
  useEffect(() => {
    Object.entries(contentTypes).forEach(([type, config]) => {
      registerContentType(type, config);
    });
  }, [contentTypes]);

  return (
    <ContentTypeContext.Provider value={null}>
      {children}
    </ContentTypeContext.Provider>
  );
};

ContentTypeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  contentTypes: PropTypes.object,
};